<div style="overflow: hidden;">
  <div
    class="modal-title"
    [ngClass]="{ 'modal-title-error': data?.type === statusEnum.error }"
  >
    {{ data?.title }}
  </div>
  <div class="modal-body">
    <div class="error-label">
      <svg-icon
        [src]="
          data?.type === statusEnum.error
            ? '../../../../assets/icons/cancel.svg'
            : '../../../../assets/icons/ckeck-exito.svg'
        "
        [svgStyle]="{
          'width.rem': 2.37,
          'height.rem': 1.25,
          position: 'relative',
          'top.rem': 0.15
        }"
      ></svg-icon>

      {{ data?.message }}
    </div>
    <div class="button-row">
      <button mat-stroked-button [mat-dialog-close]="true" class="close-button">
        Cerrar
      </button>
    </div>
  </div>
</div>
